module.exports = __webpack_public_path__ + "static/media/instluminarias2.924cfb54.webp";